<template>
  <div class="applicationTwo" id="applicationTwo">
    <my-header />

    <!-- 定制 -->
    <div class="pre">
      <div class="allTitle">
        <span>定制</span>
      </div>
    </div>

    <!-- 图片1 -->
    <div class="img1">
      <img src="../assets/dz1.jpg" />
    </div>

    <div class="card">
      <b-container class="cardBar">
        <b-row no-gutters>
          <b-col class="col" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <img src="../assets/dz2.jpg" />
          </b-col>
          <b-col
            class="col cardWordOne"
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <div class="cardTitle">您的想法,我们的灵感</div>
            <div class="cardWord1">
              近三十年来,瀚佰锐五金一直在寻求客户的灵感。<br />
              一直不断地努力学习钻研现代铜加工工艺,保证生产流程的顺畅和对产品品质的全面监控,与此同时,也一直追求对装饰五金款式的自我创新,大力开展产品开发,
            </div>
            <div class="cardWord1">
              “永不拒绝”的理念是我们公司赖以建立的基础。<br />
              如今,我们继续秉承这一传统,与客户合作,以真正的工匠魅力创造出独一无二的设计。
            </div>
          </b-col>
          <b-col
            class="col cardWordTwo"
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <div class="cardTitle1">文化的传承</div>
            <div class="cardWord2">
              尽可能的保留其文化的同时进行二次创作或者保留原来的外观。我们创建了原始设计的精细复制，让产品融入进去，不破坏其环境和文化，让历史建筑更具观赏价值。
            </div>
          </b-col>
          <b-col class="col" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <img src="../assets/dz3.jpg" />
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="design pre" id="design">
      <div class="wordTitle" id="wordTitle">
        <span>设计自己的</span>
      </div>
      <div class="word2">
        我们的新型门五金作曲器可让您混合和搭配我们的面板，把手和饰面，从而打造出满足您需求的独特作品。
      </div>
      <div class="designStyle clear">
        <div class="designTitle">
          <span
            v-for="(currect, i) in catalogList"
            v-on:click="loadDataList(currect.id)"
          >
            <router-link to="#">{{ currect.name }}</router-link>
          </span>
        </div>
        <div class="phoneDesignTitle">
          <span
            v-for="(currect, i) in catalogList"
            v-on:click="loadDataList(currect.id)"
          >
            <router-link to="#">{{ currect.name }}</router-link>
          </span>

          <!-- <span>
						<router-link to="#">所有</router-link>
					</span>
					<span>
						<router-link to="#">简约</router-link>
					</span>
					<span>
						<router-link to="#">欧式</router-link>
					</span>
					<span>
						<router-link to="#">中式</router-link>
					</span>
					<span>
						<router-link to="#">美式</router-link>
					</span>
					<span>
						<router-link to="#">饰面1</router-link>
					</span> -->
        </div>

        <div class="designImg clear">
          <div class="left" v-for="(currect, i) in dataList">
            <img :src="currect.imgPath" />
            <div class="designButton">
              <p>{{ currect.name }}</p>
              <!-- <el-button type="text">从此开始</el-button> -->
              <el-button type="text">
                <a
                  href="javascript:void(0)"
                  @click="
                    toView(
                      '/hbrApplicationDesign?go=hbrApplicationDesign',
                      'hbrApplicationDesign',
                      currect.id
                    )
                  "
                  >从此开始</a
                >
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <my-footer class="footer" style="margin-top: -12px;" />
    </div>
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      catalogList: [],
      dataList: [],
      catalogId: this.$route.query.catalogId
    };
  },
  mounted() {
    if (this.$route.query.go) {
      // debugger
      document.querySelector("#" + this.$route.query.go).scrollIntoView(true);
    }
    //加载分类
    let that = this;
    that.$axios
      .get(that.$global.baseURL + "/web/productDiyCatalog/getCatalogData.form")
      .then(res => {
        if (res.data.jsonArray == "error") {
          uni.showModal({
            title: res.data.errorInfo,
            showCancel: false
          });
        } else {
          that.catalogList = res.data.dataList;
        }
      });
    that.loadDataList(that.catalogId);
  },
  methods: {
    toView(path, goId, id) {
      if (this.$route.fullPath != path) {
        this.$router.push({
          path,
          query: {
            id: id
          }
        });
      } else {
        document.querySelector("#" + goId).scrollIntoView(true);
      }
    },
    loadDataList(catalogId) {
      //加载列表
      let that = this;
      that.$axios
        .get(
          that.$global.baseURL +
            "/web/productDiy/getProductDataByCatalogId.form",
          {
            params: {
              catalogId: catalogId
            }
          }
        )
        .then(res => {
          if (res.data.jsonArray == "error") {
            uni.showModal({
              title: res.data.errorInfo,
              showCancel: false
            });
          } else {
            that.dataList = res.data.dataList;
          }
        });
    }
  }
};
</script>

<style>
/*最外层 */
.applicationTwo .pre {
  width: 100%;
}

/* 第一行标题 */
.applicationTwo .pre .allTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  padding: 40px 0;
  letter-spacing: 20px;
  padding-left: 20px;
  font-weight: lighter;
}

.applicationTwo .pre .wordTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #595757;
  font-size: 45px;
  padding-top: 45px;
  letter-spacing: 10px;
  font-weight: lighter;
}

.applicationTwo .pre .word2 {
  width: 88%;
  margin: 0 auto;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 1px;
  color: #595757;
}

.applicationTwo .img1 img {
  width: 100%;
  /* 
		margin: 30px 0 100px; */
  margin-bottom: 100px;
}

.card {
  width: 100%;
  border: 0;
  margin-top: 30px;
  padding-bottom: 80px;
  border-bottom: 1px solid #c4c4c4;
}

.card .cardBar {
  width: 80%;
}

.card img {
  width: 100%;
}

.card .cardWordOne {
  text-align: left;
  padding-left: 50px;
  color: #595757;
}

.card .cardWordTwo {
  text-align: left;
  color: #595757;
}

.card .cardWordOne .cardTitle {
  font-size: 40px;
  font-weight: lighter;
  letter-spacing: 5px;
  margin-top: 40px;
  margin-bottom: 10px;
}

.card .cardWordTwo .cardTitle1 {
  font-size: 40px;
  font-weight: lighter;
  letter-spacing: 10px;
  padding-top: 100px;
}

.card .cardWordOne .cardWord1 {
  padding-top: 30px;
  font-size: 15px;
  line-height: 28px;
  letter-spacing: 1px;
}

.card .cardWordTwo .cardWord2 {
  width: 75%;
  font-size: 15px;
  letter-spacing: 1px;
  line-height: 28px;
  padding-top: 40px;
}

.col-change {
  padding-right: 0px !important;
  padding-left: 5px !important;
}

.design {
  width: 100%;
}

.designStyle {
  width: 100%;
  background-color: #efefef;
  margin: 0 auto;
  margin-top: 50px;
  padding-bottom: 120px;
}

.designStyle .designTitle {
  width: 70%;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  padding-top: 75px;
}

.designStyle .designTitle span {
  letter-spacing: 2px;
  margin: 0 auto;
  padding: 0px 45px;
}

.designStyle .designTitle a {
  text-decoration: none;
  color: #595757;
}

.designStyle .designTitle a:hover {
  text-decoration: none;
  color: #ccb356;
}

.designStyle .designImg {
  width: 90%;
  margin: 0 auto;
}

.designStyle .designImg div {
  width: 33.3%;
  margin: 0 auto;
}

.designImg img {
  width: 330px;
  height: 330px;
  margin: 0 auto;
  margin-top: 75px;
  /* margin-left: 42px; */
  text-align: center;
  display: block;
}

.designImg .designButton {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  /* margin-left: 20px; */
  font-size: 16px;
  letter-spacing: 2px;
}

.designImg .designButton p {
  margin-top: 15px;
}

.designImg .designButton span {
  border: 1px solid #ccb356;
  padding: 8px 10px;
  color: #ccb356;
  letter-spacing: 2px;
}

.designImg .designButton a {
  color: #ccb356;
  text-decoration: none;
}

.phoneDesignTitle {
  display: none;
}

.applicationTwo .footer1 {
  margin-top: 10px;
}

@media screen and (max-width: 576px) {
  .card .cardWordOne {
    padding-left: 0px;
  }

  .projectImg img {
    margin: 75px 0 0;
    margin-left: 56px;
  }

  .card .cardWordTwo {
    margin-bottom: 40px;
  }

  .card .cardWordTwo .cardWord2 {
    width: 100%;
  }

  .designTitle {
    display: none;
  }

  .phoneDesignTitle {
    width: 100%;
    text-align: center;
    display: block;
    margin-top: 30px;
  }

  .phoneDesignTitle span {
    padding: 20px 16px;
    position: relative;
    top: 33px;
  }

  .phoneDesignTitle span a {
    color: #595757;
  }

  .phoneDesignTitle span a:hover {
    color: #ccb356;
    text-decoration: none;
  }

  .designStyle .designImg .left {
    /* margin-left: 14px; */
    width: 100%;
    margin: 0 auto;
  }

  .designStyle .designImg div {
  }

  /* .applicationTwo .footer{
			margin-top: -10px;
		} */
}
</style>
